import Assets from '@lib/Assets'
import Card from '../edit-page/Card';
import MessagesApiService from '../../api-services/MessagesAPIService'
import MessageApiService from '../../api-services/MessageAPIService'
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import buildResourcePath from '@lib/buildResourcePath'
import HelpSystemInformation from '../common/HelpSystemInformation';
import Loader from '../common/Loader';

export default class CommunicationCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            messagesFromDocumentReady: true,
            inputText: '',
            messages: [],
            sending: false,
            initializing: true
        };

        this.communicationInputRef = React.createRef();
        this.communicationInputIconRef = React.createRef();

        scheduleAtDocumentReady(() => {
            this.messageApiService = APIServicesRegistry.getService(this.props.messageApiService);
            this.messagesApiService = APIServicesRegistry.getService(this.props.messagesApiService);
            this.loadMessages().then((result) => {
                this.setState({
                    messages: result.data.data,
                    initializing: false
                })
            });
        })
    }

    createFilterData() {

        let projectNumber = this.getProjectNumber();
        if (projectNumber === 0)
            return null;
        return {
            filter: {
                external: true,
                application: this.props.appType,
                projectNumber: {operation: "in", values: [projectNumber]}
            }
        };
    }

    getProjectId() {
        return this.props.projectId || 0;
    }

    getProjectNumber() {
        return this.props.projectNumber || "";
    }

    loadMessages() {
        let filterData = this.createFilterData();
        if (filterData == null) {
            this.setState({initializing: false});
            return;
        }

        return this.messagesApiService.indexPage(filterData);
    }

    showAll() {
        window.location.href = buildResourcePath(`/${this.messagesApiService.endpointControllerName}/Index?projectNumber=${this.getProjectNumber()}`);
    }

    postMessage() {
        if (this.isNewProject()) {
            return;
        }
        this.communicationInputRef.current.style.boxShadow = '';
        let tekst = this.state.inputText;
        let data = {
            content: tekst,
            external: true,
            projectId: this.props.projectId,
            applicationType: this.props.appType,
            date: new Date()
        }

        this.setState({sending: true}, () => {
            this.messageApiService.create(data).then(() => {
                this.loadMessages().then(result => {
                    this.setState({
                        messages: result.data.data,
                        initializing: false,
                        sending: false,
                        inputText: '',
                        messagesFromDocumentReady: false
                    }, () => {
                        this.onMessageInputBlud();
                    })
                });
            })
        })
    }

    inputTextChanged(value) {
        let v = value.target.value || '';
        this.setState({inputText: v});
    }

    renderMessage(message) {
        return (
            <React.Fragment>
                <div className="message-header">
                    <div className="header-left">
                        <div className="message-author">{message.sendBy}</div>
                        {message.read ? '' : <div className="new-message-tag">{__('New')}</div>}
                    </div>
                    <div className="header-right ">{message.date}</div>
                </div>
                <div className="message-content">{message.message}</div>
            </React.Fragment>
        );
    }

    renderLabel = () => <a className="btn-show-all" onClick={() => this.showAll()}>{__('Show all')}</a>

    isNewProject = () => this.getProjectId() === 0

    createMessageList() {
        let noMessageText = this.isNewProject() ? "Save project to send messages." : "No messages within project.";
        let messages = this.state.messages;
        const getMessageClass = (i, arr) => {
            if (!this.state.messagesFromDocumentReady && i == 0) {
                return 'message-item animation'
            }
            return 'message-item';
        }

        if (messages && messages.length > 0) {
            return (
                <div className="messages-list">
                    {messages.map((m, i, arr) => <div key={m.id}
                                                      className={getMessageClass(i, arr)}>{this.renderMessage(m)}</div>)}
                </div>
            );
        }

        return (<div className="empty-list text-muted">{__(noMessageText)}</div>);

    }

    renderTitle = () => {
        return (
            <div className="card-title">
                <div className="title">
                    <span>{__('Communication')}</span>
                    <HelpSystemInformation text={this.props.helpInfo}/>
                </div>
                {!this.isNewProject() && (
                    <div className="card-buttons">
                        {this.renderLabel()}
                    </div>
                )}
            </div>
        )
    }

    onMessageInputFocus = () => {
        this.communicationInputRef.current.style.boxShadow = '0 2px 20px -6px rgba(10,54,123,.5)';
        this.communicationInputIconRef.current.style.borderColor = 'rgba(10,54,123,.1)';
    }

    onMessageInputBlud = () => {
        this.communicationInputRef.current.style.boxShadow = '';
        this.communicationInputIconRef.current.style.border = '1px solid #9da4b3';
        this.communicationInputIconRef.current.style.borderLeft = 0;
    }

    onMessageKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.postMessage()
        }
    }

    renderMessages = () => {
        return (
            <React.Fragment>
                {this.createMessageList()}
                {!this.isNewProject() && (
                    <div className="communications-input-wrapper">
                        <div className="communications-input" ref={this.communicationInputRef}>
                            {this.state.sending && this.renderLoader()}
                            <input
                                onFocus={this.onMessageInputFocus}
                                onBlur={this.onMessageInputBlud}
                                onKeyDown={this.onMessageKeyDown}
                                className="message-input"
                                placeholder={__('Start writing a message')}
                                type="text" value={this.state.inputText}
                                onChange={(v) => this.inputTextChanged(v)}
                                disabled={this.state.sending}
                                readOnly={this.isNewProject()}>

                            </input>
                            <div className="icon" ref={this.communicationInputIconRef}>
                                <img src={Assets['sendMessage']} onClick={() => this.postMessage()}></img>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }

    render() {
        return (
            <Card className="project-communication-card" editableMode={false} editable={false}
                  customTitle={() => this.renderTitle()}>
                {this.state.initializing ? <Loader fillContainer={true}/> : this.renderMessages()}
            </Card>
        )
    }

    renderLoader() {
        return (
            <div className="loading-overlay" style={{backgroundColor: '#ffffff'}}>
                <div className="ball-loader visible">
                    <div className="ball-loader-ball1"></div>
                    <div className="ball-loader-ball2"></div>
                    <div className="ball-loader-ball3"></div>
                </div>
            </div>
        )
    }
}

